import { GET_PRIZES, GET_PRIZES_FAIL, GET_PRIZES_SUCCESS, ADD_REDEMPTION, ADD_REDEMPTION_SUCCESS, ADD_REDEMPTION_FAIL, UPDATE_REDEMPTION, UPDATE_REDEMPTION_SUCCESS, UPDATE_REDEMPTION_FAIL, GET_REDEMPTIONS_ACTIVITY, GET_REDEMPTIONS_ACTIVITY_SUCCESS, GET_REDEMPTIONS_ACTIVITY_FAIL, ADD_ACTIVITY, ADD_ACTIVITY_SUCCESS, ADD_ACTIVITY_FAIL } from "./actionTypes"

export const getPrizes = () => ({
  type: GET_PRIZES,
})

export const getPrizesSuccess = prizes => ({
  type: GET_PRIZES_SUCCESS,
  payload: prizes,
})

export const getPrizesFail = error => ({
  type: GET_PRIZES_FAIL,
  payload: error,
})

export const getRedemptionsActivity = username => {
  console.log(username)
  return {
      type: GET_REDEMPTIONS_ACTIVITY,
      payload: username,
  }
}

export const getRedemptionsActivitySuccess = profile => ({
  type: GET_REDEMPTIONS_ACTIVITY_SUCCESS,
  payload: profile,
})

export const getRedemptionsActivityFail = error => ({
  type: GET_REDEMPTIONS_ACTIVITY_FAIL,
  payload: error,
})

export const addRedemption = (redemption) => ({
  type: ADD_REDEMPTION,
  payload: redemption
})

export const addRedemptionSuccess = profile  => ({
  type: ADD_REDEMPTION_SUCCESS,
  payload: profile
})

export const addRedemptionFail = error => ({
  type: ADD_REDEMPTION_FAIL,
  payload: error,
})

export const updateRedemption = (redemption) => ({
  type: UPDATE_REDEMPTION,
  payload: redemption
})

export const updateRedemptionSuccess = profile  => ({
  type: UPDATE_REDEMPTION_SUCCESS,
  payload: profile
})

export const updateRedemptionFail = error => ({
  type: UPDATE_REDEMPTION_FAIL,
  payload: error,
})

export const addActivity = (activity) => ({
  type: ADD_ACTIVITY,
  payload: activity
})

export const addActivitySuccess = profile  => ({
  type: ADD_ACTIVITY_SUCCESS,
  payload: profile
})

export const addActivityFail = error => ({
  type: ADD_REDEMPTION_FAIL,
  payload: error,
})


